import React, { useEffect, useState } from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import useReactApexChart from "../../hook/useReactApexChart";
import { Icon } from "@iconify/react/dist/iconify.js";

import axios from "axios";
import DashboardComp from "../../components/DashboardComp/DashboardComp";


const DashboardPage = () => {
  let { createChart } = useReactApexChart();

  return (
    <MasterLayout>
      {/* <Breadcrumb title="" /> */}
      <DashboardComp/>
    </MasterLayout>
  );
};

export default DashboardPage;
